<template>
  <TimeslotDashboardLayout>
    <div class="main-content settings">
      <div>
        <div class="content-div">
          <div class="tap-heading-div">
            <h1 class="tab-heading">Settings</h1>
            <div class="tab-text"></div>
            <div class="no-update_wrapper" style="display:none;">
              <div class="no-update_content">
                <img
                  src="https://uploads-ssl.webflow.com/629917a86b347b2be85e67ff/629917a86b347be87e5e6851_timer.svg"
                  loading="lazy"
                  alt=""
                />
                <div class="no-update-yet">Nothing to show here</div>
                <div class="appointments">
                  Appointments with professionals would show up here
                </div>
                <a href="#" class="explore-professionals_button w-button"
                  >Explore professionals</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        data-current="Tab 1"
        data-easing="ease"
        data-duration-in="300"
        data-duration-out="100"
        class="tabs w-tabs"
      >
        <div class="tabs-menu-2 w-tab-menu">
          <a
            data-w-tab="Tab 1"
            @click="openPersonal"
            :class="
              personal
                ? 'booking-tab w-inline-block w-tab-link w--current'
                : 'booking-tab w-inline-block w-tab-link'
            "
          >
            <div>Personal Info</div>
          </a>
          <!--          <a-->
          <!--            data-w-tab="Tab 2"-->
          <!--            @click="openPayment"-->
          <!--            :class="-->
          <!--              payment-->
          <!--                ? 'booking-tab w-inline-block w-tab-link w&#45;&#45;current'-->
          <!--                : 'booking-tab w-inline-block w-tab-link'-->
          <!--            "-->
          <!--          >-->
          <!--            <div>Account Info</div>-->
          <!--          </a>-->
          <a
            data-w-tab="Tab 3"
            @click="openSecurity"
            :class="
              security
                ? 'booking-tab w-inline-block w-tab-link w--current'
                : 'booking-tab w-inline-block w-tab-link'
            "
          >
            <div>Reset Password</div>
          </a>
        </div>

        <div class="w-tab-content">
          <div
            data-w-tab="Tab 1"
            :class="personal ? 'w-tab-pane w--tab-active' : 'w-tab-pane'"
          >
            <div class="personal-info">
              <div class="payment-info-wrapper">
                <div class="profile-picture-wrapper">
                  <div class="div-block-96">
                    <input
                      type="file"
                      @change="onImageSelect"
                      accept="image/x-png,image/jpeg"
                      id="upload-profile"
                    />
                    <img
                      loading="lazy"
                      alt=""
                      class="profile-picture-timeslot"
                      :src="
                        updateModel.customerDisplayPicture ||
                          customerInfo.customerDisplayPicture ||
                          require('@/assets/timeslot-images/Profile-pics.svg')
                      "
                    />
                    <a
                      href="#"
                      class="link-block-8 w-inline-block"
                      @click="uploadProfile"
                    ></a>
                  </div>
                  <div>
                    <div>
                      <BaseComponentLoader
                        v-if="
                          loader.nonBlockingLoader &&
                            !name &&
                            !about &&
                            !country &&
                            !timezone &&
                            !phone &&
                            !interest &&
                            pictureLoad
                        "
                        loaderAlignment="center"
                      />
                      <a
                        v-else
                        href="#"
                        class="link-15"
                        @click="uploadImageProfile"
                        >Upload profile picture</a
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="first-name-wrapper">
                <div class="title-wrapper">
                  <div class="text-block-73">Name</div>
                  <div class="div-block-97">
                    <div>
                      <a
                        href="#"
                        data-w-id="f8439559-0469-b343-0ce1-6b417602d5c1"
                        class="cancel-btn"
                        @click="toggleName"
                        v-if="name"
                        >Cancel</a
                      >
                    </div>
                    <div>
                      <a
                        href="#"
                        data-w-id="f8439559-0469-b343-0ce1-6b417602d5c4"
                        class="edit-btn"
                        @click="toggleName"
                        v-if="!name"
                        >Edit</a
                      >
                    </div>
                  </div>
                </div>
                <div class="saved-name-wrapper" v-if="!name">
                  <div class="text-block-74">
                    {{ customerInfo.customerName }}
                  </div>
                </div>
                <div class="edit-name" v-if="name">
                  <div class="text-block-75">Full Name</div>
                  <input
                    type="text"
                    class="text-field settings w-input"
                    maxlength="256"
                    name="field-5"
                    data-name="Field 5"
                    placeholder="Enter name"
                    id="field-5"
                    required=""
                    v-model="updateModel.customerName"
                  />
                  <BaseComponentLoader
                    v-if="
                      loader.nonBlockingLoader &&
                        !about &&
                        !country &&
                        !timezone &&
                        !phone &&
                        !interest
                    "
                    loaderAlignment="left"
                  />
                  <a
                    data-w-id="f8439559-0469-b343-0ce1-6b417602d5cd"
                    href="#"
                    class="button-18 w-button"
                    @click="closeName"
                    v-else
                  >
                    Update
                  </a>
                </div>
              </div>
              <div class="about-wrapper">
                <div class="title-wrapper">
                  <div class="text-block-73">About</div>
                  <div class="div-block-97">
                    <div>
                      <a
                        href="#"
                        class="cancel-btn"
                        @click="toggleAbout"
                        v-if="about"
                        >Cancel</a
                      >
                    </div>
                    <div>
                      <a
                        href="#"
                        data-w-id="31679b58-e423-a2b4-2900-5d5b8cfcae31"
                        @click="toggleAbout"
                        class="edit-btn"
                        v-if="!about"
                        >Edit</a
                      >
                    </div>
                  </div>
                </div>
                <div class="saved-description" v-if="!about">
                  <div class="text-block-74">
                    {{ customerInfo.customerAbout }}
                  </div>
                </div>
                <div class="edit-description" v-if="about">
                  <div class="text-block-75">About</div>
                  <FormulateInput
                    type="textarea"
                    v-model="updateModel.customerAbout"
                    :value="userInfo.customerAbout"
                    validation="max:5000,length"
                    input-class="text-field rich-text w-input"
                  />
                  <BaseComponentLoader
                    v-if="
                      loader.nonBlockingLoader &&
                        !name &&
                        !country &&
                        !timezone &&
                        !phone &&
                        !interest
                    "
                    loaderAlignment="left"
                  />
                  <a
                    href="#"
                    class="button-18 w-button"
                    @click="closeAbout"
                    v-else
                    >Update</a
                  >
                </div>
              </div>
              <div class="country-wrapper">
                <div class="title-wrapper">
                  <div class="text-block-73">Country</div>
                  <div class="div-block-97">
                    <div>
                      <a
                        href="#"
                        class="cancel-btn"
                        @click="toggleCountry"
                        v-if="country"
                        >Cancel</a
                      >
                    </div>
                    <div>
                      <a
                        href="#"
                        class="edit-btn"
                        @click="toggleCountry"
                        v-if="!country"
                        >Edit</a
                      >
                    </div>
                  </div>
                </div>
                <div class="saved-country" v-if="!country">
                  <div class="text-block-74">
                    {{ customerInfo.customerCountry }}
                  </div>
                </div>
                <div class="edit-country" v-if="country">
                  <div class="text-block-75">Select country</div>
                  <FormulateInput
                    type="select"
                    validation="required"
                    name="country"
                    validation-name="Country"
                    placeholder="Country"
                    :options="countries"
                    v-model="updateModel.customerCountry"
                  />
                  <BaseComponentLoader
                    v-if="
                      loader.nonBlockingLoader &&
                        !about &&
                        !name &&
                        !timezone &&
                        !phone &&
                        !interest
                    "
                    loaderAlignment="left"
                  />
                  <a
                    href="#"
                    v-else
                    class="button-18 w-button"
                    @click="closeCountry"
                    >Update</a
                  >
                </div>
              </div>
              <div class="phone-number-wrapper">
                <div class="title-wrapper">
                  <div class="text-block-73">Phone number</div>
                  <div class="div-block-97">
                    <div>
                      <a
                        href="#"
                        class="cancel-btn"
                        @click="togglePhone"
                        v-if="phone"
                        >Cancel</a
                      >
                    </div>
                    <div>
                      <a
                        href="#"
                        data-w-id="58429a83-496c-7aa6-635b-a566e162047f"
                        class="edit-btn"
                        @click="togglePhone"
                        v-if="!phone"
                        >Edit</a
                      >
                    </div>
                  </div>
                </div>
                <div class="saved-name-wrapper" v-if="!phone">
                  <div class="text-block-74">
                    {{ customerInfo.customerPhoneNumber }}
                  </div>
                </div>
                <div class="edit-name" v-if="phone">
                  <div class="text-block-75">Phone number</div>
                  <div class="flex-container">
                    <div class="child1">
                      <FormulateInput
                        type="select"
                        name="countryCode"
                        placeholder="Country code"
                        :options="codes"
                        v-model="updateModel.customerCountryCode"
                      />
                    </div>
                    <div class="child2">
                      <FormulateInput
                        type="text"
                        validation="number"
                        v-model="updateModel.customerPhoneNumber"
                        placeholder="Phone number"
                      />
                    </div>
                  </div>
                  <BaseComponentLoader
                    v-if="
                      loader.nonBlockingLoader &&
                        !about &&
                        !country &&
                        !name &&
                        !timezone &&
                        !interest
                    "
                    loaderAlignment="left"
                  />

                  <a
                    v-else
                    href="#"
                    class="button-18 w-button"
                    @click="closePhone"
                    >Update</a
                  >
                </div>
              </div>
              <div class="timezone-wrappers">
                <div class="title-wrapper">
                  <div class="text-block-73">Timezone</div>
                  <div class="div-block-97">
                    <div>
                      <a
                        href="#"
                        class="cancel-btn"
                        @click="toggleTimezone"
                        v-if="timezone"
                        >Cancel</a
                      >
                    </div>
                    <div>
                      <a
                        href="#"
                        class="edit-btn"
                        @click="toggleTimezone"
                        v-if="!timezone"
                        >Edit</a
                      >
                    </div>
                  </div>
                </div>
                <div class="saved-timezone" v-if="!timezone">
                  <div class="text-block-74">
                    {{ customerInfo.customerTimezone }}
                  </div>
                </div>
                <div class="saved-timezones" v-if="timezone">
                  <div class="text-block-75">Select timezone</div>
                  <FormulateInput
                    type="select"
                    validation="required"
                    name="timezone"
                    validation-name="Timezone"
                    placeholder="Select your timezone"
                    :options="timezones"
                    v-model="updateModel.customerTimezone"
                  />
                  <BaseComponentLoader
                    v-if="
                      loader.nonBlockingLoader &&
                        !about &&
                        !country &&
                        !name &&
                        !phone &&
                        !interest
                    "
                    loaderAlignment="left"
                  />
                  <a
                    href="#"
                    v-else
                    class="button-18 w-button"
                    @click="closeTimezone"
                    >Update</a
                  >
                </div>
              </div>
              <div class="interest-wrapper">
                <div class="title-wrapper">
                  <div class="text-block-73">Interest</div>
                  <div class="div-block-97">
                    <div>
                      <a
                        href="#"
                        class="cancel-btn"
                        @click="toggleInterest"
                        v-if="interest"
                        >Cancel</a
                      >
                    </div>
                    <div>
                      <a
                        href="#"
                        data-w-id="9a67be6f-4ac0-883d-25ee-67df94af44b9"
                        class="update-btn"
                        @click="toggleInterest"
                        v-if="!interest"
                        >Update</a
                      >
                    </div>
                  </div>
                </div>
                <div class="saved-name-wrapper" v-if="!interest">
                  <div class="text-block-74">
                    {{ customerInfo.customerInterest }}
                  </div>
                </div>
                <div class="interest-select" v-if="interest">
                  <div class="text-block-75">Enter your interest</div>
                  <input
                    type="text"
                    class="text-field settings w-input"
                    maxlength="256"
                    name="field-5"
                    data-name="Field 5"
                    placeholder="Enter your field of interest"
                    id="field-5"
                    required=""
                    v-model="updateModel.customerInterest"
                  />
                  <BaseComponentLoader
                    v-if="
                      loader.nonBlockingLoader &&
                        !about &&
                        !country &&
                        !name &&
                        !phone &&
                        !timezone
                    "
                    loaderAlignment="left"
                  />
                  <a
                    v-else
                    href="#"
                    class="button-18 w-button"
                    @click="closeInterest"
                    >Update</a
                  >
                </div>
              </div>
            </div>
          </div>
          <!--          <div-->
          <!--            data-w-tab="Tab 2"-->
          <!--            :class="payment ? 'w-tab-pane w&#45;&#45;tab-active' : 'w-tab-pane'"-->
          <!--          >-->
          <!--            <div class="personal-info">-->
          <!--              <div class="payment-info-wrapper"></div>-->
          <!--              &lt;!&ndash;              <div class="about-wrapper">&ndash;&gt;-->
          <!--              &lt;!&ndash;                <div class="title-wrapper">&ndash;&gt;-->
          <!--              &lt;!&ndash;                  <div class="text-block-73">Account Number</div>&ndash;&gt;-->
          <!--              &lt;!&ndash;                  <div class="div-block-97">&ndash;&gt;-->
          <!--              &lt;!&ndash;                    <div>&ndash;&gt;-->
          <!--              &lt;!&ndash;                      <div&ndash;&gt;-->
          <!--              &lt;!&ndash;                        class="cancel-btn"&ndash;&gt;-->
          <!--              &lt;!&ndash;                        @click="toggleNumber"&ndash;&gt;-->
          <!--              &lt;!&ndash;                        v-if="number"&ndash;&gt;-->
          <!--              &lt;!&ndash;                      >&ndash;&gt;-->
          <!--              &lt;!&ndash;                        Cancel&ndash;&gt;-->
          <!--              &lt;!&ndash;                      </div>&ndash;&gt;-->
          <!--              &lt;!&ndash;                    </div>&ndash;&gt;-->
          <!--              &lt;!&ndash;                    <div>&ndash;&gt;-->
          <!--              &lt;!&ndash;                      <div&ndash;&gt;-->
          <!--              &lt;!&ndash;                        class="edit-btn"&ndash;&gt;-->
          <!--              &lt;!&ndash;                        @click="toggleNumber"&ndash;&gt;-->
          <!--              &lt;!&ndash;                        v-if="!number"&ndash;&gt;-->
          <!--              &lt;!&ndash;                      >&ndash;&gt;-->
          <!--              &lt;!&ndash;                        Edit&ndash;&gt;-->
          <!--              &lt;!&ndash;                      </div>&ndash;&gt;-->
          <!--              &lt;!&ndash;                    </div>&ndash;&gt;-->
          <!--              &lt;!&ndash;                  </div>&ndash;&gt;-->
          <!--              &lt;!&ndash;                </div>&ndash;&gt;-->
          <!--              &lt;!&ndash;                <div class="saved-description" v-if="!number">&ndash;&gt;-->
          <!--              &lt;!&ndash;                  <div class="text-block-74">&ndash;&gt;-->
          <!--              &lt;!&ndash;                    {{ customerInfo.payOutAccountNumber }}&ndash;&gt;-->
          <!--              &lt;!&ndash;                  </div>&ndash;&gt;-->
          <!--              &lt;!&ndash;                </div>&ndash;&gt;-->
          <!--              &lt;!&ndash;                <div class="edit-description" v-if="number">&ndash;&gt;-->
          <!--              &lt;!&ndash;                  <div class="text-block-75">Account Number</div>&ndash;&gt;-->
          <!--              &lt;!&ndash;                  <input&ndash;&gt;-->
          <!--              &lt;!&ndash;                    id="field-5"&ndash;&gt;-->
          <!--              &lt;!&ndash;                    name="field-5"&ndash;&gt;-->
          <!--              &lt;!&ndash;                    maxlength="256"&ndash;&gt;-->
          <!--              &lt;!&ndash;                    type="text"&ndash;&gt;-->
          <!--              &lt;!&ndash;                    class="text-field settings w-input"&ndash;&gt;-->
          <!--              &lt;!&ndash;                    data-name="field"&ndash;&gt;-->
          <!--              &lt;!&ndash;                    placeholder="Account number"&ndash;&gt;-->
          <!--              &lt;!&ndash;                    v-model="paymentModel.payOutAccountNumber"&ndash;&gt;-->
          <!--              &lt;!&ndash;                  />&ndash;&gt;-->
          <!--              &lt;!&ndash;                  <BaseComponentLoader&ndash;&gt;-->
          <!--              &lt;!&ndash;                    v-if="loader.nonBlockingLoader && !bank"&ndash;&gt;-->
          <!--              &lt;!&ndash;                    loaderAlignment="left"&ndash;&gt;-->
          <!--              &lt;!&ndash;                  />&ndash;&gt;-->

          <!--              &lt;!&ndash;                  <div v-else class="button-18 w-button" @click="closeNumber">&ndash;&gt;-->
          <!--              &lt;!&ndash;                    Update&ndash;&gt;-->
          <!--              &lt;!&ndash;                  </div>&ndash;&gt;-->
          <!--              &lt;!&ndash;                </div>&ndash;&gt;-->
          <!--              &lt;!&ndash;              </div>&ndash;&gt;-->
          <!--              &lt;!&ndash;              <div class="country-wrapper">&ndash;&gt;-->
          <!--              &lt;!&ndash;                <div class="title-wrapper">&ndash;&gt;-->
          <!--              &lt;!&ndash;                  <div class="text-block-73">Bank</div>&ndash;&gt;-->
          <!--              &lt;!&ndash;                  <div class="div-block-97">&ndash;&gt;-->
          <!--              &lt;!&ndash;                    <div>&ndash;&gt;-->
          <!--              &lt;!&ndash;                      <div class="cancel-btn" v-if="bank" @click="toggleBank">&ndash;&gt;-->
          <!--              &lt;!&ndash;                        Cancel&ndash;&gt;-->
          <!--              &lt;!&ndash;                      </div>&ndash;&gt;-->
          <!--              &lt;!&ndash;                    </div>&ndash;&gt;-->
          <!--              &lt;!&ndash;                    <div>&ndash;&gt;-->
          <!--              &lt;!&ndash;                      <div class="edit-btn" v-if="!bank" @click="toggleBank">&ndash;&gt;-->
          <!--              &lt;!&ndash;                        Edit&ndash;&gt;-->
          <!--              &lt;!&ndash;                      </div>&ndash;&gt;-->
          <!--              &lt;!&ndash;                    </div>&ndash;&gt;-->
          <!--              &lt;!&ndash;                  </div>&ndash;&gt;-->
          <!--              &lt;!&ndash;                </div>&ndash;&gt;-->
          <!--              &lt;!&ndash;                <div class="saved-country" v-if="!bank">&ndash;&gt;-->
          <!--              &lt;!&ndash;                  <div class="text-block-74">&ndash;&gt;-->
          <!--              &lt;!&ndash;                    {{ customerInfo.payOutAccountBank }}&ndash;&gt;-->
          <!--              &lt;!&ndash;                  </div>&ndash;&gt;-->
          <!--              &lt;!&ndash;                </div>&ndash;&gt;-->
          <!--              &lt;!&ndash;                <div class="edit-country" v-if="bank">&ndash;&gt;-->
          <!--              &lt;!&ndash;                  <div class="text-block-75">Bank</div>&ndash;&gt;-->
          <!--              &lt;!&ndash;                  <input&ndash;&gt;-->
          <!--              &lt;!&ndash;                    type="text"&ndash;&gt;-->
          <!--              &lt;!&ndash;                    class="text-field settings w-input"&ndash;&gt;-->
          <!--              &lt;!&ndash;                    maxlength="256"&ndash;&gt;-->
          <!--              &lt;!&ndash;                    name="field-5"&ndash;&gt;-->
          <!--              &lt;!&ndash;                    data-name="Field 5"&ndash;&gt;-->
          <!--              &lt;!&ndash;                    placeholder="Enter name"&ndash;&gt;-->
          <!--              &lt;!&ndash;                    id="field-5"&ndash;&gt;-->
          <!--              &lt;!&ndash;                    required=""&ndash;&gt;-->
          <!--              &lt;!&ndash;                    v-model="paymentModel.payOutAccountBank"&ndash;&gt;-->
          <!--              &lt;!&ndash;                  />&ndash;&gt;-->

          <!--              &lt;!&ndash;                  <BaseComponentLoader&ndash;&gt;-->
          <!--              &lt;!&ndash;                    v-if="loader.nonBlockingLoader && !number"&ndash;&gt;-->
          <!--              &lt;!&ndash;                    loaderAlignment="left"&ndash;&gt;-->
          <!--              &lt;!&ndash;                  />&ndash;&gt;-->

          <!--              &lt;!&ndash;                  <div v-else class="button-18 w-button" @click="closeBank">&ndash;&gt;-->
          <!--              &lt;!&ndash;                    Update&ndash;&gt;-->
          <!--              &lt;!&ndash;                  </div>&ndash;&gt;-->
          <!--              &lt;!&ndash;                </div>&ndash;&gt;-->
          <!--              &lt;!&ndash;              </div>&ndash;&gt;-->
          <!--              <div class="country-wrapper">-->
          <!--                <div class="title-wrapper">-->
          <!--                  <div class="text-block-73">Country</div>-->
          <!--                  <div class="div-block-97">-->
          <!--                    <div>-->
          <!--                      <div-->
          <!--                        class="cancel-btn"-->
          <!--                        v-if="stripeCountry"-->
          <!--                        @click="toggleStripeCountry"-->
          <!--                      >-->
          <!--                        Cancel-->
          <!--                      </div>-->
          <!--                    </div>-->
          <!--                    <div>-->
          <!--                      <div-->
          <!--                        class="edit-btn"-->
          <!--                        v-if="!stripeCountry"-->
          <!--                        @click="toggleStripeCountry"-->
          <!--                      >-->
          <!--                        Edit-->
          <!--                      </div>-->
          <!--                    </div>-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--                <div class="saved-country" v-if="!stripeCountry">-->
          <!--                  <div class="text-block-74">-->
          <!--                    &lt;!&ndash;                    {{ customerInfo.payOutAccountBank }}&ndash;&gt;-->
          <!--                    Country-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--                <div class="edit-country" v-if="stripeCountry">-->
          <!--                  <div class="text-block-75">Select country</div>-->
          <!--                  <div class="child1">-->
          <!--                    <FormulateInput-->
          <!--                      type="select"-->
          <!--                      validation="required"-->
          <!--                      name="country"-->
          <!--                      validation-name="Country"-->
          <!--                      placeholder="Country"-->
          <!--                      :options="payOutCountries"-->
          <!--                      v-model="createStripeAccountModel.countryCode"-->
          <!--                      @change="createStripePayoutAccount"-->
          <!--                    />-->
          <!--                  </div>-->
          <!--                  <BaseComponentLoader-->
          <!--                    v-if="loader.nonBlockingLoader"-->
          <!--                    loaderAlignment="left"-->
          <!--                  />-->
          <!--                  <div-->
          <!--                    v-else-->
          <!--                    class="button-18 w-button"-->
          <!--                    @click="closeStripeCountry"-->
          <!--                  >-->
          <!--                    Update-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--              <div-->
          <!--                class="phone-number-wrapper"-->
          <!--                v-if="-->
          <!--                  isNigeria ||-->
          <!--                    customerInfo.payOutAccountCountry === 'NG' ||-->
          <!--                    customerInfo.payOutAccountCountry === 'Nigeria'-->
          <!--                "-->
          <!--              >-->
          <!--                <div class="title-wrapper">-->
          <!--                  <div class="text-block-73">Account details</div>-->
          <!--                  <div class="div-block-97">-->
          <!--                    <div>-->
          <!--                      <div class="cancel-btn" @click="toggleBank" v-if="bank">-->
          <!--                        Cancel-->
          <!--                      </div>-->
          <!--                    </div>-->
          <!--                    <div>-->
          <!--                      <div-->
          <!--                        data-w-id="58429a83-496c-7aa6-635b-a566e162047f"-->
          <!--                        class="edit-btn"-->
          <!--                        @click="toggleBank"-->
          <!--                        v-if="!bank"-->
          <!--                      >-->
          <!--                        Edit-->
          <!--                      </div>-->
          <!--                    </div>-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--                <div class="saved-name-wrapper" v-if="!bank">-->
          <!--                  <div-->
          <!--                    class="text-block-74"-->
          <!--                    v-if="-->
          <!--                      customerInfo.payOutAccountBank &&-->
          <!--                        customerInfo.payOutAccountNumber-->
          <!--                    "-->
          <!--                  >-->
          <!--                    {{ customerInfo.payOutAccountBank }}-->
          <!--                    <span-->
          <!--                      v-if="-->
          <!--                        'payOutAccountBank' in customerInfo &&-->
          <!--                          'payOutAccountNumber' in customerInfo-->
          <!--                      "-->
          <!--                      >-</span-->
          <!--                    >-->
          <!--                    {{ customerInfo.payOutAccountNumber }}-->
          <!--                  </div>-->
          <!--                  <div class="text-block-74" v-else>Account details</div>-->
          <!--                </div>-->
          <!--                <div class="edit-name" v-if="bank">-->
          <!--                  &lt;!&ndash;                  <div class="text-block-75">Account details</div>&ndash;&gt;-->
          <!--                  <div class="flex-container">-->
          <!--                    <div class="child1">-->
          <!--                      <FormulateInput-->
          <!--                        type="text"-->
          <!--                        validation-name="Account name"-->
          <!--                        :placeholder="accountName"-->
          <!--                        v-model="paymentModel.payOutAccountName"-->
          <!--                      />-->
          <!--                    </div>-->
          <!--                    <div class="child2">-->
          <!--                      <FormulateInput-->
          <!--                        type="text"-->
          <!--                        validation-name="Bank"-->
          <!--                        :placeholder="accountBank"-->
          <!--                        v-model="paymentModel.payOutAccountBank"-->
          <!--                      />-->
          <!--                    </div>-->
          <!--                  </div>-->
          <!--                  <div class="flex-container">-->
          <!--                    <div class="child1">-->
          <!--                      <FormulateInput-->
          <!--                        type="text"-->
          <!--                        validation-name="Account number"-->
          <!--                        :placeholder="accountNumber"-->
          <!--                        v-model="paymentModel.payOutAccountNumber"-->
          <!--                      />-->
          <!--                    </div>-->
          <!--                    &lt;!&ndash;                    <div class="child2">&ndash;&gt;-->
          <!--                    &lt;!&ndash;                      <FormulateInput&ndash;&gt;-->
          <!--                    &lt;!&ndash;                        type="select"&ndash;&gt;-->
          <!--                    &lt;!&ndash;                        validation="required"&ndash;&gt;-->
          <!--                    &lt;!&ndash;                        name="country"&ndash;&gt;-->
          <!--                    &lt;!&ndash;                        validation-name="Country"&ndash;&gt;-->
          <!--                    &lt;!&ndash;                        placeholder="Country"&ndash;&gt;-->
          <!--                    &lt;!&ndash;                        :options="countriesStripe"&ndash;&gt;-->
          <!--                    &lt;!&ndash;                        v-model="paymentModel.payOutAccountCountry"&ndash;&gt;-->
          <!--                    &lt;!&ndash;                      />&ndash;&gt;-->
          <!--                    &lt;!&ndash;                    </div>&ndash;&gt;-->
          <!--                    <div class="div-block-235">-->
          <!--                      &lt;!&ndash;                    <label for="name-4" class="field-label-22">OTP</label>&ndash;&gt;-->
          <!--                      <div class="div-block-162">-->
          <!--                        <input-->
          <!--                          type="text"-->
          <!--                          class="text-field-25 w-input"-->
          <!--                          maxlength="256"-->
          <!--                          name="name-3"-->
          <!--                          data-name="Name 3"-->
          <!--                          placeholder="OTP"-->
          <!--                          id="name-3"-->
          <!--                          v-model="otp"-->
          <!--                        />-->
          <!--                        <a href="#" class="button-28 w-button" v-if="otpLoader"-->
          <!--                          >Sending OTP</a-->
          <!--                        >-->
          <!--                        <a-->
          <!--                          href="#"-->
          <!--                          class="button-28 w-button"-->
          <!--                          @click="resendOtp"-->
          <!--                          v-else-->
          <!--                          >Request OTP</a-->
          <!--                        >-->
          <!--                      </div>-->
          <!--                    </div>-->
          <!--                  </div>-->
          <!--                  <div class="flex-container">-->
          <!--                    <div class="child1">-->
          <!--                      <FormulateInput-->
          <!--                        type="select"-->
          <!--                        validation="required"-->
          <!--                        name="country"-->
          <!--                        validation-name="Country"-->
          <!--                        placeholder="Country"-->
          <!--                        :options="payOutCountries"-->
          <!--                        v-model="paymentModel.payOutAccountCountry"-->
          <!--                      />-->
          <!--                    </div>-->
          <!--                  </div>-->
          <!--                  &lt;!&ndash;                  <div class="div-block-235">&ndash;&gt;-->
          <!--                  &lt;!&ndash;&lt;!&ndash;                    <label for="name-4" class="field-label-22">OTP</label>&ndash;&gt;&ndash;&gt;-->
          <!--                  &lt;!&ndash;                    <div class="div-block-162">&ndash;&gt;-->
          <!--                  &lt;!&ndash;                      <input&ndash;&gt;-->
          <!--                  &lt;!&ndash;                        type="text"&ndash;&gt;-->
          <!--                  &lt;!&ndash;                        class="text-field-25 w-input"&ndash;&gt;-->
          <!--                  &lt;!&ndash;                        maxlength="256"&ndash;&gt;-->
          <!--                  &lt;!&ndash;                        name="name-3"&ndash;&gt;-->
          <!--                  &lt;!&ndash;                        data-name="Name 3"&ndash;&gt;-->
          <!--                  &lt;!&ndash;                        placeholder="OTP"&ndash;&gt;-->
          <!--                  &lt;!&ndash;                        id="name-3"&ndash;&gt;-->
          <!--                  &lt;!&ndash;                      />&ndash;&gt;-->
          <!--                  &lt;!&ndash;                      <a href="#" class="button-28 w-button">Request OTP</a>&ndash;&gt;-->
          <!--                  &lt;!&ndash;                    </div>&ndash;&gt;-->
          <!--                  &lt;!&ndash;                  </div>&ndash;&gt;-->

          <!--                  <BaseComponentLoader-->
          <!--                    v-if="loader.nonBlockingLoader"-->
          <!--                    loaderAlignment="left"-->
          <!--                  />-->
          <!--                  <div v-else class="button-18 w-button" @click="closeBank">-->
          <!--                    Update-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
        <div
          data-w-tab="Tab 3"
          :class="security ? 'w-tab-pane w--tab-active' : 'w-tab-pane'"
        >
          <div class="personal-info">
            <div class="payment-info-wrapper"></div>
            <div class="first-name-wrapper">
              <div class="title-wrapper">
                <div class="text-block-73">Change Password</div>
                <div class="div-block-97">
                  <div>
                    <div
                      data-w-id="fb93d499-70af-9abe-011c-46212aa3b215"
                      class="cancel-btn"
                      @click="togglePassword"
                      v-if="password"
                    >
                      Cancel
                    </div>
                  </div>
                  <div>
                    <div
                      data-w-id="fb93d499-70af-9abe-011c-46212aa3b218"
                      class="edit-btn"
                      @click="togglePassword"
                      v-if="!password"
                    >
                      Edit
                    </div>
                  </div>
                </div>
              </div>
              <div class="saved-name-wrapper" v-if="!password">
                <div class="text-block-74">******</div>
              </div>
              <div class="edit-name" v-if="password">
                <div class="text-block-75" style="margin-bottom:0;">
                  Current Password
                </div>
                <FormulateForm>
                  <img
                    v-if="type === 'password'"
                    @click="toggleOldPassword"
                    style="cursor: pointer;"
                    src="@/assets/timeslot-images/visual.png"
                    class="password-eye"
                  />
                  <img
                    @click="toggleOldPassword"
                    style="cursor: pointer;"
                    v-else
                    src="@/assets/timeslot-images/eye.png"
                    class="password-eye"
                  />
                  <FormulateInput
                    :type="type"
                    name="oldPassword"
                    placeholder="Enter your current password"
                    v-model="passwordModel.oldPassword"
                  />
                  <div class="text-block-75" style="margin-bottom:0;">
                    New Password
                  </div>
                  <img
                    v-if="typeNew === 'password'"
                    src="@/assets/timeslot-images/visual.png"
                    class="password-eye"
                    @click="toggleNewPassword"
                    style="cursor: pointer;"
                  />
                  <img
                    v-else
                    src="@/assets/timeslot-images/eye.png"
                    class="password-eye"
                    @click="toggleNewPassword"
                    style="cursor: pointer;"
                  />
                  <FormulateInput
                    :type="typeNew"
                    name="password"
                    placeholder="Enter your new password"
                    validation-name="New password"
                    validation="bail|required"
                    v-model="passwordModel.password"
                    error-behavior="value"
                    :validation-messages="{
                      matches:
                        'Password must contain at least one number, an uppercase letter, a lowercase letter and a special character.'
                    }"
                  />
                  <div class="text-block-75" style="margin-bottom:0;">
                    Confirm New Password
                  </div>
                  <img
                    v-if="typeConfirm === 'password'"
                    src="@/assets/timeslot-images/visual.png"
                    class="password-eye"
                    @click="toggleNewPassword"
                    style="cursor: pointer;"
                  />
                  <img
                    v-else
                    src="@/assets/timeslot-images/eye.png"
                    class="password-eye"
                    @click="toggleNewPassword"
                    style="cursor: pointer;"
                  />
                  <FormulateInput
                    :type="typeConfirm"
                    name="password_confirm"
                    validation="required|confirm"
                    placeholder="Confirm your new password"
                    validation-name="Password confirmation"
                    v-model="passwordModel.passwordConfirmation"
                  />
                </FormulateForm>
                <BaseComponentLoader
                  v-if="loader.nonBlockingLoader"
                  loaderAlignment="left"
                />
                <a
                  v-else
                  href="#"
                  class="button-18 w-button"
                  @click="closePassword"
                  >Update</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SuccessMessageModal
      v-if="changePasswordSuccess"
      :button-action="closeModal"
      :message="'You have changed your password successfully'"
      :cancel="closeModal"
    />
    <template v-slot:right-side-nav>
      <div></div>
    </template>
  </TimeslotDashboardLayout>
</template>

<script>
import TimeslotDashboardLayout from "@/views/timeslot/TimeslotDashboardLayout";
import { mapState } from "vuex";
import CustomerRequest from "@/model/requests/CustomerRequest";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import BaseComponentLoader from "@/components/BaseComponents/BaseComponentLoader";
import { countryCodes } from "@/utils/country/countryCodes";
import AuthRequest from "@/model/requests/AuthRequest";
import PayOutAccountRequest from "@/model/requests/PayOutAccountRequest";
import SuccessMessageModal from "@/components/modal/SuccessMessageModal";

export default {
  name: "CustomerSettings",
  components: {
    TimeslotDashboardLayout,
    BaseComponentLoader,
    SuccessMessageModal
  },
  data() {
    return {
      profilepicture: "",
      imageFile: null,
      personal: true,
      payment: false,
      security: false,
      name: false,
      about: false,
      country: false,
      timezone: false,
      phone: false,
      interest: false,
      picture: false,
      account: false,
      number: false,
      bank: false,
      country2: false,
      payment2: false,
      withdraw: false,
      password: false,
      updateModel: CustomerRequest.update,
      load: false,
      imageModel: CustomerRequest.uploadImage,
      readModel: CustomerRequest.readBy,
      passwordModel: AuthRequest.changePassword,
      paymentModel: PayOutAccountRequest.update,
      image: "visual",
      type: "password",
      typeConfirm: "password",
      typeNew: "password",
      isNigeria: false,
      stripeCountry: false,
      createStripeAccountModel: PayOutAccountRequest.createStripePayoutAccount,
      otp: "",
      otpLoader: false,
      resendModel: AuthRequest.resendOtp,
      pictureLoad: false
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo,
      updateSuccess: state => state.customer.updateSuccess,
      customerInfo: state => state.customer.customerInfo,
      imageUrl: state => state.customer.imageUrl,
      changePasswordSuccess: state => state.auth.changePasswordSuccess,
      payOut: state => state.payOutAccount.payOutAccount
    }),
    countries() {
      return countryCodes.map(data => {
        return { label: data.name, value: data.name };
      });
    },
    codes() {
      return countryCodes.map(data => {
        return {
          label: `${data.name}:${data.dial_code}`,
          value: data.dial_code,
          id: data.code
        };
      });
    },
    timezones() {
      return StoreUtils.rootGetters("customer/getTimezones");
    },
    timezoneList() {
      return this.timezones.map(data => {
        return {
          label: `${data.timeZoneName}:${data.timeZoneOffset}(${data.timeZoneAbbreviation})`,
          value: data.timeZoneName,
          id: data.timeZoneId
        };
      });
    },
    updateValue() {
      return StoreUtils.rootGetters("customer/getUpdateSuccess");
    },
    ...mapState(["loader"]),
    payOutCountries() {
      return countryCodes.map(data => {
        return { label: data.name, value: data.code, id: data.id };
      });
    },
    accountName() {
      if (this.customerInfo.payOutAccountName) {
        return this.customerInfo.payOutAccountName;
      } else {
        return "Account name";
      }
    },
    accountBank() {
      if (this.customerInfo.payOutAccountBank) {
        return this.customerInfo.payOutAccountBank;
      } else {
        return "Bank";
      }
    },
    accountNumber() {
      if (this.customerInfo.payOutAccountNumber) {
        return this.customerInfo.payOutAccountNumber;
      } else {
        return "Account number";
      }
    }
  },
  methods: {
    uploadProfile() {
      document.getElementById("upload-profile").click();
    },
    createURL(imageFile) {
      let reader = new FileReader();
      reader.onload = e =>
        (this.updateModel.customerDisplayPicture = e.target.result);
      reader.readAsDataURL(imageFile);
    },
    onImageSelect(e) {
      const files = e.target.files;

      if (files.length) {
        this.createURL(files[0]);
      }
    },
    uploadImageProfile() {
      this.imageModel.base64 = this.updateModel.customerDisplayPicture;
      this.imageModel.type = "profile";
      this.imageModel.customerId = this.userInfo.customerId;
      StoreUtils.dispatch("customer/uploadImage", this.imageModel).then(
        () => (this.pictureLoad = true)
      );
    },
    openPersonal() {
      this.personal = true;
      this.payment = false;
      this.security = false;
    },
    openPayment() {
      this.personal = false;
      this.payment = true;
      this.security = false;
    },
    openSecurity() {
      this.payment = false;
      this.security = true;
      this.personal = false;
    },
    toggleName() {
      this.name = !this.name;
    },
    closeModal() {
      StoreUtils.commit("auth/SET_CHANGE_PASSWORD_SUCCESS", false);
    },
    test() {},
    closeName() {
      this.updateModel.customerId = this.userInfo.customerId;
      StoreUtils.dispatch("customer/updateCustomer", this.updateModel).then(
        () => {
          this.name = false;
        }
      );
    },
    toggleAbout() {
      this.about = !this.about;
    },
    uploadProfilePicture() {
      this.updateModel.customerId = this.userInfo.customerId;
      StoreUtils.dispatch("customer/updateCustomer", this.updateModel);
    },
    closeAbout() {
      this.updateModel.customerId = this.userInfo.customerId;
      StoreUtils.dispatch("customer/updateCustomer", this.updateModel).then(
        () => {
          this.about = false;
        }
      );
    },
    toggleCountry() {
      this.country = !this.country;
    },
    closeCountry() {
      this.updateModel.customerId = this.userInfo.customerId;
      StoreUtils.dispatch("customer/updateCustomer", this.updateModel).then(
        () => {
          this.country = false;
        }
      );
    },
    toggleTimezone() {
      this.timezone = !this.timezone;
    },
    closeTimezone() {
      this.updateModel.customerId = this.userInfo.customerId;
      StoreUtils.dispatch("customer/updateCustomer", this.updateModel).then(
        () => {
          this.timezone = false;
        }
      );
    },
    togglePhone() {
      this.phone = !this.phone;
    },
    closePhone() {
      this.updateModel.customerId = this.userInfo.customerId;
      StoreUtils.dispatch("customer/updateCustomer", this.updateModel).then(
        () => {
          this.phone = false;
        }
      );
    },
    toggleInterest() {
      this.interest = !this.interest;
    },
    closeInterest() {
      this.updateModel.customerId = this.userInfo.customerId;
      StoreUtils.dispatch("customer/updateCustomer", this.updateModel).then(
        () => {
          this.interest = false;
        }
      );
    },
    togglePicture() {
      this.picture = !this.picture;
    },
    closePicture() {
      this.updateModel.customerId = this.userInfo.customerId;
      StoreUtils.dispatch("customer/updateCustomer", this.updateModel);
    },
    toggleAccount() {
      this.account = !this.account;
    },
    closeAccount() {
      this.paymentModel.payOutAccountCustomerId = this.userInfo.customerId;
      StoreUtils.dispatch(
        "payOutAccount/updatePayOutAccount",
        this.paymentModel
      ).then(() => {
        this.account = false;
      });
    },
    toggleNumber() {
      this.number = !this.number;
    },
    closeNumber() {
      this.paymentModel.payOutAccountCustomerId = this.userInfo.customerId;
      StoreUtils.dispatch(
        "payOutAccount/updatePayOutAccount",
        this.paymentModel
      ).then(() => {
        this.number = false;
      });
    },
    toggleBank() {
      this.bank = !this.bank;
    },
    closeBank() {
      this.paymentModel.payOutAccountCustomerId = this.userInfo.customerId;
      this.paymentModel.otp = this.otp;
      StoreUtils.dispatch(
        "payOutAccount/updatePayOutAccount",
        this.paymentModel
      ).then(() => {
        this.bank = false;
        this.otp = "";
      });
    },
    toggleCountry2() {
      this.country2 = !this.country2;
    },
    closeCountry2() {
      this.country2 = false;
    },
    togglePayment2() {
      this.payment2 = !this.payment2;
    },
    closePayment2() {
      this.payment2 = false;
    },
    toggleWithdraw() {
      this.withdraw = !this.withdraw;
    },
    closeWithdraw() {
      this.withdraw = false;
    },
    togglePassword() {
      this.password = !this.password;
    },
    closePassword() {
      this.passwordModel.username = this.userInfo.customerEmail;
      this.passwordModel.countryCode = this.userInfo.customerCountryCode;
      StoreUtils.dispatch("auth/changePassword", this.passwordModel).then(
        () => {
          this.password = false;
        }
      );
    },
    toggleOldPassword() {
      if (this.type === "password") {
        this.type = "text";
        this.image = "eye";
      } else {
        this.type = "password";
        this.image = "visual";
      }
    },
    toggleNewPassword() {
      if (this.typeNew === "password") {
        this.typeNew = "text";
        this.image = "eye";
      } else {
        this.typeNew = "password";
        this.image = "visual";
      }
    },
    toggleConfirmPassword() {
      if (this.typeConfirm === "password") {
        this.typeConfirm = "text";
        this.image = "eye";
      } else {
        this.typeConfirm = "password";
        this.image = "visual";
      }
    },
    toggleStripeCountry() {
      this.stripeCountry = !this.stripeCountry;
    },
    closeStripeCountry() {
      this.stripeCountry = false;
    },
    createStripePayoutAccount() {
      // StoreUtils.dispatch(
      //   "payOutAccount/createStripePayoutAccount",
      //   this.createStripeAccountModel
      // );
      if (this.createStripeAccountModel.countryCode !== "NG")
        StoreUtils.dispatch(
          "payOutAccount/createStripePayoutAccount",
          this.createStripeAccountModel
        );
    },
    resendOtp() {
      this.resendModel.username = this.userInfo.customerEmail;
      this.resendModel.countryCode = "234";
      StoreUtils.dispatch(StoreUtils.actions.auth.RESEND_OTP, this.resendModel);
    }
  },
  mounted() {
    StoreUtils.dispatch("customer/readTimezones");
    this.readModel.customerId = this.userInfo.customerId;
    StoreUtils.dispatch("customer/readByCustomerId", this.readModel);
  },
  watch: {
    otpLoading(newValue) {
      if (newValue === true) {
        return (this.otpLoader = true);
      } else {
        return (this.otpLoader = false);
      }
    },
    "createStripeAccountModel.countryCode"(newValue) {
      if (newValue === "NG") {
        this.isNigeria = true;
      } else {
        this.isNigeria = false;
      }
    }
  }
};
</script>

<style scoped>
.flex-container {
  display: flex;
  /*justify-content: space-between;*/
  gap: 10px;
}
.child1 {
  width: 50%;
}
.child2 {
  width: 50%;
}
.profile-picture-timeslot {
  cursor: pointer;
}
#upload-profile {
  /*height: 123px;*/
  /*border-radius: 10px;*/
  /*border-color: red;*/
}
.profile-picture-timeslot {
  height: 116px;
  width: 116px;
  border-radius: 10px;
  /*object-fit:cover;*/
  max-width: 100%;
}
.password-eye {
  position: relative;
  top: 38px;
  left: 90%;
  width: 20px;
  height: 20px;
  opacity: 0.7;
}
input[type="file"] {
  height: 23px;
  width: 23px;
  border-radius: 50%;
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

@media only screen and (max-width: 600px) {
  .text-field-25 {
    height: 50px;
    width: 100%;
  }
  .button-28 {
    width: 100%;
    height: 50px;
  }
}
</style>
